// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__V-3kV","unreadBadge":"styles_unreadBadge__2cwwg","modalContent":"styles_modalContent__1E76-","modal":"styles_modal__2tV1U"};